import type { DateStripItem } from "@/shared/ui"

import { civilDate, nextDay, prevDay } from "./dayMath"

/**
 * Builds a date strip for the Records view spanning `pastDays` before today
 * through `futureDays` after today (inclusive).
 *
 * Unlike the forward-only `buildDateStrip` in `rescheduleDays.ts`, past days
 * are NOT disabled — the records view allows navigating backward.
 */
export function buildRecordsDateStrip(
  now: Date,
  tz: string,
  pastDays = 2,
  futureDays = 14,
  current?: string,
): DateStripItem[] {
  const today = civilDate(now, tz)
  const currentVal = current ?? today

  // Build past dates in chronological order (oldest first)
  const pastDates: string[] = []
  let d = today
  for (let i = 0; i < pastDays; i++) {
    d = prevDay(d, tz)
    pastDates.unshift(d)
  }

  const items: DateStripItem[] = []

  for (const date of pastDates) {
    items.push({ value: date, isToday: false, isCurrent: date === currentVal })
  }

  items.push({ value: today, isToday: true, isCurrent: today === currentVal })

  d = today
  for (let i = 0; i < futureDays; i++) {
    d = nextDay(d, tz)
    items.push({ value: d, isToday: false, isCurrent: d === currentVal })
  }

  return items
}
